<template>
    <group-report-template  v-model:current-report-template-id="currentReportTemplateId"
                            :template-id="templateId"
                            v-model:for-group="forGroup"
                            v-model:interval="interval"
                            v-model:ran-report="reportSuccessfullySent"
                            v-model:reload-data="reloadTable"
                            v-model:running-errors="errorSending"
                            v-model:running-report="runningReport"
                            v-model:settings="settings"
                            :can-edit="permissions.can('manage_system_health_report')"
                            :users="users"
                            :default-settings="defaultSettings"
                            :prepare-settings-function="prepareSettings"
                            :hide-title="true"
                            :use-settings-drawer="true"
                            :use-template-cards="true"
                            :use-group-reporting-option="groupReportingEnabled"
                            :has-settings="hasManualRunSettings"
                            :has-run-inputs="false"
                            :report-icon="settingsSchema.icon"
                            :schema="settingsSchema"
                            report-name="system-health-report"
                            v-model:display-section="displaySection"
                            @useStandardReporting="setUseStandardReporting"
    >
        <template   #create-settings>
            <report-settings-panel  v-model="settings"
                                    v-model:interval="interval"
                                    :schema="settingsSchema"
                                    :is-savable="true"
                                    :context="settingsContext"
            ></report-settings-panel>
        </template>

        <template   #edit-settings>
            <report-settings-panel  v-model="settings"
                                    v-model:interval="interval"
                                    :schema="settingsSchema"
                                    :is-savable="displaySection === 'show-template' || useStandardReporting"
                                    :context="settingsContext"
            ></report-settings-panel>
        </template>

        <template   #run-options="props">
            <!-- A point-in-time snapshot: nothing to pick, so the shared run
                 form renders no inputs. It still runs the report, from the page
                 header's Run Report (or the run slide-over's footer for a saved
                 template). Toggle values post via extraParams. -->
            <interval-selection :use-meters="false"
                                :footer-mode="props.footerMode ?? 'none'"
                                :is-running="runningReport"
                                :ran-report="reportSuccessfullySent"
                                :running-errors="errorSending ?? []"
                                @run-report="runReport(props.reportTemplateId ?? null)"
            ></interval-selection>
        </template>
    </group-report-template>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import {useGroupReport} from "@/composables/useGroupReport";

import GroupReportTemplate from "./GroupReportTemplate";
import ReportSettingsPanel from "./settings/ReportSettingsPanel.vue";
import IntervalSelection from "./IntervalSelection";
import systemHealthSettingsSchema from "./settings/schemas/system-health";

export default {
    name: "GroupSystemHealthReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        GroupReportTemplate,
        ReportSettingsPanel,
        IntervalSelection,
    },
    props: {
        // null on the report page; 'new' or a group report id on its New or
        // Edit page.
        templateId: {
            type: [String, Number],
            default: null,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        users: {
            type: Object,
            default() {
                return {}
            }
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    setup(props) {
        // The composable supplies settingsContext, hasManualRunSettings, and
        // prepareSettings (weekday default); this schema has no permission-gated
        // fields. extraParams posts the three check toggles the report reads
        // (it snapshots current state, so there is no window or meters to send).
        const report = useGroupReport(systemHealthSettingsSchema, {
            interval: props.interval,
            defaultSettings: props.defaultSettings,
            weekdayDefault: 1,
            extraParams: (state) => ({
                show_health_checks: state.settings.value['show_health_checks'],
                show_battery_checks: state.settings.value['show_battery_checks'],
                show_calibration_checks: state.settings.value['show_calibration_checks'],
            }),
        })

        return {...report}
    },
    computed: {
        settingsSchema() {
            return systemHealthSettingsSchema
        },
    },
}
</script>
